import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/auth";
import { CATEGORIES, eur } from "@/lib/constants";
import EditionFormulaCards from "@/components/EditionFormulaCards";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);

  return (
    <div data-testid="page-services">
      <section className="cs-cream border-b border-black/10 py-20">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="cs-eyebrow text-neutral-500">Prestations</div>
          <h1 className="cs-h1 mt-4 text-5xl lg:text-7xl max-w-3xl">Toutes les prestations de l'atelier.</h1>
          <p className="mt-6 max-w-2xl text-neutral-700 cs-body">
            De la correction d'un simple PDF jusqu'à la mise en page complète d'un livre illustré,
            chaque prestation est décrite, chiffrée et pensée pour un imprimeur.
          </p>
        </div>
      </section>

      {CATEGORIES.map((cat) => {
        const list = services.filter((s) => s.category === cat.slug);
        const isEdition = cat.slug === "edition";
        if (!isEdition && list.length === 0) return null;
        return (
          <section key={cat.slug} className="cs-cream py-20 border-b border-black/10" data-testid={`services-section-${cat.slug}`}>
            <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
              <div className="flex items-end justify-between mb-10">
                <div>
                  <div className="cs-eyebrow text-neutral-500">{cat.eyebrow}</div>
                  <h2 className="cs-h2 mt-3 text-4xl lg:text-5xl">{cat.label}</h2>
                  <p className="mt-3 max-w-xl text-neutral-700">{cat.description}</p>
                </div>
                {!isEdition && (
                  <Link to={`/services/${cat.slug}`} className="hidden md:inline-block cs-link-underline text-sm">
                    Voir la catégorie →
                  </Link>
                )}
                {isEdition && (
                  <Link to="/mise-en-page" className="hidden md:inline-block cs-link-underline text-sm" data-testid="edition-open-configurator">
                    Ouvrir le configurateur →
                  </Link>
                )}
              </div>

              {isEdition ? (
                <EditionFormulaCards testIdPrefix="svc-edition" />
              ) : (
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {list.map((s) => (
                    <Link key={s.id} to={`/prestation/${s.slug}`} className="cs-card p-8 flex flex-col justify-between min-h-[240px]"
                      data-testid={`svc-card-${s.slug}`}>
                      <div>
                        <h3 className="cs-h3 text-2xl">{s.name}</h3>
                        <p className="mt-3 text-sm text-neutral-600 line-clamp-3">{s.short_description}</p>
                      </div>
                      <div className="mt-6 flex items-end justify-between">
                        <div>
                          <div className="text-xs font-mono text-neutral-500">À partir de</div>
                          <div className="font-serif text-3xl">{eur(s.starting_price)}</div>
                        </div>
                        <ArrowUpRight size={20} />
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </section>
        );
      })}
    </div>
  );
}
